export const UPDATE_DRAFT = 'drafts/UPDATE'
export const CREATE_DRAFT = 'drafts/CREATE'
export const DELETE_DRAFT = 'drafts/DELETE'
export const STORED_DRAFT = 'drafts/STORED'
export const FAILED_DRAFT = 'drafts/FAILED'
export const FAILED_SEND = 'drafts/FAILED_SEND'

export const DRAFT_RECIPIENT_SYNC_STARTED = 'drafts/RECIPIENT_SYNC_STARTED'
export const DRAFT_RECIPIENT_SYNC_FINISHED = 'drafts/RECIPIENT_SYNC_FINISHED'
